import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainScreen from "./MainScreen";
import ARCompassMultiStop from "./IndoorARCompass";
import IndoorARNavigator from "./Steps";
import ARStepNavigator from "../src/navigation/ARStepNavigator";
import WalkingDirectionOnboarding from "./onboarding/onboarding";
import WalkingDirectionOnboardings from "./onboarding/onboardings";
import Onboarding from "./onboarding/explainers";




export default function App() {
  const seen = localStorage.getItem("onboardingSeen") === "true";
  return seen ? <WalkingDirectionOnboardings /> : <Onboarding />;
  return (
    <Router>
      <Routes>
        {/* <Route path="/location" element={<MainScreen />} /> */}
         {/* <Route path="/" element={<ARCompassMultiStop />} /> */}
        {/* <Route path="/" element={<ARStepNavigator />} /> */}
          {/* <Route path="/" element={<WalkingDirectionOnboarding />} /> */}
          <Route path="/" element={<WalkingDirectionOnboardings />} />

         {/* <Route path="/" element={<IndoorARNavigator />} /> */}
      </Routes>
    </Router>
  );
}
// export default App;
